import React from 'react';
import { Button } from 'antd';
import styles from './DaylongMoreBtn.module.scss';

const DaylongMoreBtn = ({ style, count, onClick }) => {
  return (
    <Button
      style={style}
      className={styles.root}
      type="primary"
      ghost
      onClick={onClick}
    >
      <span className={styles.accent}>{`Еще ${count}`}</span>
      Показать все
    </Button>
  );
};

export default DaylongMoreBtn;
